import React, {PureComponent} from "react";
import PropTypes from 'prop-types';
import Button from "react-bootstrap/Button";
import ArrowRight from "../../../assets/arrow-right.png";
import ArrowLeft from "../../../assets/arrow-left.png";
import './index.css'
import {debug} from "../../../utility/functions";

export default class Pagination extends PureComponent {


	constructor(props) {
		super(props);
		this.state = {
			currentPage: props.currentPage
		}
	}

	getUrlWithPage = (page) => {
		if (this.props.baseUrl) {
			return this.props.baseUrl + "?page=" + page
		}
		return page
	};

	onPageButtonClicked = (page) => {
		if (this.props.onPageClicked) {
			this.props.onPageClicked(this.getUrlWithPage(page))
		}
		this.setState({
			currentPage: page,
		}, () => {
			if (this.props.onPageChanged) {
				this.props.onPageChanged(this.getUrlWithPage(page))
			}
		});

	};

	onNextButtonClicked = () => {
		let nextPage = this.state.currentPage + 1;
		if (this.props.onNextClicked) {
			this.props.onNextClicked(this.getUrlWithPage(nextPage));
		}
		this.setState({
			currentPage: nextPage,
		}, () => {
			if (this.props.onPageChanged) {
				this.props.onPageChanged(this.getUrlWithPage(nextPage))
			}
		});
	};

	onPreviousButtonClicked = () => {
		let prevPage = this.state.currentPage - 1;
		if (this.props.onPreviousClicked) {
			this.props.onPreviousClicked(this.getUrlWithPage(prevPage));
		}
		this.setState({
			currentPage: prevPage,
		}, () => {
			if (this.props.onPageChanged) {
				this.props.onPageChanged(this.getUrlWithPage(prevPage))
			}
		});
	};

	renderPages = () => {
		const {totalPages, totalMarginPages} = this.props;
		let {maxPagesToShow} = this.props;

		if (maxPagesToShow < 3) {
			maxPagesToShow = 2;
		} else {
			maxPagesToShow--;
		}

		let {currentPage} = this.props;

		let pages = [], middlePages = [], prevMarginPages = [], nextMarginPages = [], prevBreak = [], nextBreak = [];
		let previousPages, nextPages;

		pages = this.getPages();
		previousPages = this.getPreviousPages(pages);
		nextPages = this.getNextPages(pages);

		let middleLeftPages = 0, middleRightPages = 0;

		if (maxPagesToShow % 2 === 0) {
			middleLeftPages = maxPagesToShow / 2;
			middleRightPages = maxPagesToShow / 2;
		} else {
			if (previousPages.length > nextPages.length) {
				middleLeftPages = Math.ceil(maxPagesToShow / 2);
				middleRightPages = Math.floor(maxPagesToShow / 2);
			} else {
				middleLeftPages = Math.floor(maxPagesToShow / 2);
				middleRightPages = Math.ceil(maxPagesToShow / 2);
			}
		}

		let rest = 0;

		if (previousPages.length < middleLeftPages) {
			rest += middleLeftPages - previousPages.length;
			middleLeftPages = previousPages.length;
		}

		if (nextPages.length < middleRightPages) {
			rest += middleRightPages - nextPages.length;
			middleRightPages = nextPages.length;
		}

		debug("Rest -> ", rest);
		while ((previousPages.length > middleLeftPages || nextPages.length > middleRightPages) && (middleLeftPages + middleRightPages < maxPagesToShow)) {
			if (previousPages.length > middleLeftPages) {
				middleLeftPages++;
			}

			if (nextPages.length > middleRightPages) {
				middleRightPages++;
			}
		}

		middlePages = pages.filter((value, index) => {
			if (value >= currentPage - middleLeftPages - 1 && value <= currentPage + middleRightPages + 1) {
				if (index === 0 || index === pages.length - 1) {
					return value
				} else if (value >= currentPage - middleLeftPages && value <= currentPage + middleRightPages) {
					return value
				}
			}
		});

		let i = 0;
		prevMarginPages = pages.filter(value => {
			if (i < totalMarginPages) {
				if (value < currentPage - middleLeftPages - 1) {
					i++;
					return value
				}
			}
		});

		i = 0;

		nextMarginPages = pages.sort((a, b) => b - a).filter(value => {
			if (i < totalMarginPages) {
				if (value > currentPage + middleRightPages + 1) {
					i++;
					return value
				}
			}
		});

		if (prevMarginPages.length > 0) {
			prevBreak = ['...']
		}

		if (nextMarginPages.length > 0) {
			nextBreak = ['...']
		}

		return (
			<div className='pagination-pages'>
				{this.renderFirstPageButton()}
				{this.renderPrevMarginPages(prevMarginPages)}
				{this.renderPrevBreak(prevBreak)}
				{this.renderMiddlePages(middlePages)}
				{this.renderNextBreak(nextBreak)}
				{this.renderNextMarginPages(nextMarginPages)}
				{this.renderLastPageButton()}
			</div>
		)

	};

	getPages = () => {
		const {totalPages} = this.props;
		const pages = [];
		for (let i = 0; i < totalPages; i++) {
			pages.push(i + 1);
		}
		return pages;
	};

	getPreviousPages = (pages = this.getPages()) => {
		const {currentPage} = this.props;
		return pages.filter(value => {
			return value < currentPage;
		});
	};

	getNextPages = (pages = this.getPages()) => {
		const {currentPage} = this.props;
		return pages.filter(value => {
			return value > currentPage;
		});
	};

	renderFirstPageButton = () => {
		const {currentPage ,totalPages, totalMarginPages} = this.props;
		if(totalMarginPages > 0 && currentPage !== 1) {
			return(
				<div
					key={1}
					className={"pagination-page-button pagination-page-button-first"}
					onClick={() => {
						this.onPageButtonClicked(1)
					}}
				>
					<div className='pagination-page-text'>{1}</div>
				</div>
			)
		}
	};

	renderLastPageButton = () => {
		const {currentPage, totalPages, totalMarginPages} = this.props;
		if(totalMarginPages > 0 && currentPage !== totalPages) {
			return(
				<div
					key={totalPages}
					className={"pagination-page-button pagination-page-button-last"}
					onClick={() => {
						this.onPageButtonClicked(totalPages)
					}}
				>
					<div className='pagination-page-text'>{totalPages}</div>
				</div>
			)
		}
	};

	renderPrevMarginPages = (prevMarginPages) => {
		return prevMarginPages.map(value => this.renderMarginButtons(value))
	};

	renderNextMarginPages = (nextMarginPages) => {
		return nextMarginPages.map(value => this.renderMarginButtons(value))
	};

	renderMarginButtons = (value) => {
		return (
			<div
				key={value}
				className={"pagination-page-button pagination-page-button-margin"}
				onClick={() => {
					this.onPageButtonClicked(value)
				}}
			>
				<div className='pagination-page-text'>{value}</div>
			</div>
		)
	};

	renderPrevBreak = (prevBreak) => {
		return prevBreak.map(value => this.renderBreakButtons(value))
	};

	renderNextBreak = (nextBreak) => {
		return nextBreak.map(value => this.renderBreakButtons(value))
	};

	renderBreakButtons = (value) => {
		return (
			<div key={value} className="pagination-page-button pagination-page-button-break">
				<div className='pagination-page-text'>{value}</div>
			</div>
		)
	};

	renderMiddlePages = (middlePages) => {
		const {currentPage} = this.props;
		return middlePages.map(value => {
			if (value === currentPage) {
				return this.renderActivePageButton(value)
			}
			return this.renderOtherMiddlePageButtons(value)
		})
	};

	renderActivePageButton = (value) => {
		return (
			<div className={"pagination-page-button active pagination-page-button-selected"}>{value}</div>
		)
	};

	renderOtherMiddlePageButtons = (value) => {
		return (
			<div
				key={value}
				className={"pagination-page-button pagination-page-button-other-middle"}
				onClick={() => {
					this.onPageButtonClicked(value)
				}}
			>
				<div className='pagination-page-text'>{value}</div>
			</div>
		)
	};

	_renderPaginationPreviousButton() {
		const {previous} = this.props;

		return (
			<Button className={this.getPreviousPages().length === 0 ? 'pagination-hidden-button' : 'pagination-back-button'} onClick={this.onPreviousButtonClicked}>
				<img className='pagination-back-button-icon' alt={""} style={{width: 20}} src={ArrowLeft}/>
				<div className='pagination-back-button-text'>{previous}</div>
			</Button>
		)
	}

	_renderPaginationNextButton() {
		const {next} = this.props;

		return (
			<Button className={this.getNextPages().length === 0 ? 'pagination-hidden-button' : 'pagination-front-button'} onClick={this.onNextButtonClicked}>
				<div className='pagination-front-button-text'>{next}</div>
				<img className='pagination-front-button-icon' alt={""} src={ArrowRight}/>
			</Button>
		)
	}

	render() {
		const {totalPages} = this.props;

		if(!totalPages || totalPages <= 1) {
			return null;
		}

		return (
			<div className='pagination-container'>
				<div className='pagination-back-container'>
					{this._renderPaginationPreviousButton()}
				</div>
				<div className='pagination-middle-container'>
					{this.renderPages()}
				</div>
				<div className='pagination-front-container'>
					{this._renderPaginationNextButton()}
				</div>
			</div>
		)
	}
}

Pagination.propTypes = {
	totalPages: PropTypes.number.isRequired,
	currentPage: PropTypes.number.isRequired,
	totalMarginPages: PropTypes.number,
	maxPagesToShow: PropTypes.number,
	baseUrl: PropTypes.string,
	next: PropTypes.string,
	nextIcon: PropTypes.string,
	nextContainerClass: PropTypes.string,
	previous: PropTypes.string,
	previousIcon: PropTypes.string,
	previousContainerClass: PropTypes.string,
	onNextClicked: PropTypes.func,
	onPreviousClicked: PropTypes.func,
	onPageClicked: PropTypes.func,
	onPageChanged: PropTypes.func,
};

Pagination.defaultProps = {
	currentPage: 1,
	totalPages: 1,
	totalMarginPages: 1,
	maxPagesToShow: 5,
	baseUrl: null,
	next: "Próximo",
	nextIcon: null,
	nextContainerClass: 'pagination-button',
	previous: "Anterior",
	previousIcon: null,
	previousContainerClass: 'pagination-button',
	onNextClicked: null,
	onPreviousClicked: null,
	onPageClicked: null,
	onPageChanged: null,
};

